package com.macrofocus.eflux.db

import com.macrofocus.common.json.JsonObject
import com.macrofocus.eflux.data.quest.QuestBranchPowerFlowRecord
import com.macrofocus.eflux.data.quest.QuestBusPowerFlowRecord
import com.macrofocus.eflux.data.quest.QuestZonePowerFlowRecord
import com.macrofocus.eflux.network.DerivedBranchColumn
import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.physical.Branch
import com.macrofocus.eflux.network.physical.Bus
import com.macrofocus.eflux.network.physical.Zone
import com.macrofocus.eflux.toRawString
import korlibs.time.DateTime
import kotlinx.coroutines.await
import org.molap.dataframe.DataFrame
import org.molap.dataframe.rowmajor.AccessorRowMajorDataFrame
import org.molap.dataframe.rowmajor.RowMajorDataFrame
import org.molap.questdb.DateTimeHandling
import org.molap.questdb.readQuestDBJson
import kotlin.js.Promise

suspend fun branchDataFrame(logicalBusId: LogicalBusId, shiftedDateTime: DateTime) : DataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?> {
    val promise =
        Promise.resolve(kotlinx.browser.window.fetch("/db/branches/$logicalBusId/${shiftedDateTime.toRawString()}"))

    val answer = Promise.all(arrayOf(promise)).await()
    val json = promise.await().json().await() as JsonObject
    val dataFrame = DataFrame.readQuestDBJson(json, DateTimeHandling.Long)

    val branchDataFrame: AccessorRowMajorDataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?> =
        AccessorRowMajorDataFrame<Branch, RowMajorDataFrame.Column<Branch, Any?>, Any?>(
            arrayOf(DerivedBranchColumn.datetime) +
                    DerivedBranchColumn.timeseries.filterIsInstance<RowMajorDataFrame.Column<Branch, Any?>>()
                        .toTypedArray()
        )

    val zoneMap = HashMap<String, Zone>()
    val busMap = HashMap<String, Bus>()
    for (row in dataFrame.rows()) {
        val fromZoneRecord = QuestZonePowerFlowRecord(dataFrame, row)
        val fromZone: Zone
        if(zoneMap.containsKey(fromZoneRecord.zoname)) {
            fromZone = zoneMap[fromZoneRecord.zoname]!!
        } else {
            fromZone = Zone(fromZoneRecord)
            zoneMap[fromZoneRecord.zoname] = fromZone
        }

        val fromBusRecord = QuestBusPowerFlowRecord(dataFrame, row)
        val from: Bus
        if(busMap.containsKey(fromBusRecord.name)) {
            from = busMap[fromBusRecord.name]!!
        } else {
            from = Bus(fromBusRecord, fromZone)
            busMap[fromBusRecord.name] = from
        }

        val toZoneRecord = QuestZonePowerFlowRecord(dataFrame, row, "1")
        val toZone: Zone
        if(zoneMap.containsKey(toZoneRecord.zoname)) {
            toZone = zoneMap[toZoneRecord.zoname]!!
        } else {
            toZone = Zone(toZoneRecord)
            zoneMap[toZoneRecord.zoname] = toZone
        }

        val toBusRecord = QuestBusPowerFlowRecord(dataFrame, row, "1")
        val to: Bus
        if(busMap.containsKey(toBusRecord.name)) {
            to = busMap[toBusRecord.name]!!
        } else {
            to = Bus(toBusRecord, toZone)
            busMap[toBusRecord.name] = to
        }

        val branchRecord = QuestBranchPowerFlowRecord(dataFrame, row)
        val branch: Branch = Branch(from, to, branchRecord)

        branchDataFrame.addRow(branch)
    }
    return branchDataFrame
}